var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M16.834 9.167a7.633 7.633 0 0 1-1.585 4.668l2.958 2.958a1 1 0 1 1-1.414 1.414l-2.958-2.958a7.667 7.667 0 1 1 2.999-6.082m-13.334 0a5.667 5.667 0 1 1 9.756 3.923 1 1 0 0 0-.166.166 5.667 5.667 0 0 1-9.59-4.09",
  clipRule: "evenodd"
})));
SvgSearch.displayName = "SvgSearch";
export { SvgSearch as ReactComponent };
export default SvgSearch;